import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { Root, Text, Image } from './index.styled';

const Logo = () => {

  return (
    <Root>
      <Image>
        <StaticImage src="./assets/logo.png" alt="Logo" />
      </Image>
      <Text>Accounting</Text>
    </Root>
  );

};

export { Logo };